"use client";

import Image from "next/image";
import Link from "next/link";
import React, { useEffect, useState } from "react";
import NavMenu from "./NavMenu";

const Navbar = () => {
      const [navbar, setNavbar] = useState(false);
      const [appStoreUrl, setAppStoreUrl] = useState("https://play.google.com/store/apps/details?id=com.bonoholdings.proptech");

      const changeBackground = () => {
            if (window.scrollY >= 10) {
                  setNavbar(true);
            } else {
                  setNavbar(false);
            }
      };

      useEffect(() => {
            window.addEventListener("scroll", changeBackground);
            return () => {
                  window.removeEventListener("scroll", changeBackground);
            };
      }, []);

      useEffect(() => {
            // Detect platform and set appropriate app store URL
            const userAgent = navigator.userAgent || navigator.vendor || window.opera;
            const platform = navigator.platform || navigator.userAgentData?.platform || "";

            // Check for iOS (iPhone, iPad, iPod)
            const isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
            // Check for Mac
            const isMac = /Macintosh|MacIntel|MacPPC|Mac68K/.test(platform);
            // Check for Android
            const isAndroid = /android/i.test(userAgent);
            // Check for Windows
            const isWindows = /Win/.test(platform);

            if (isIOS || isMac) {
                  setAppStoreUrl("https://apps.apple.com/gb/app/olmo-homes/id6747893455");
            } else if (isAndroid || isWindows) {
                  setAppStoreUrl("https://play.google.com/store/apps/details?id=com.bonoholdings.proptech");
            }
      }, []);

      return (
            <>
                  <header
                        className={`header-nav nav-homepage-style light-header menu-home4 main-menu ${navbar ? "sticky slideInDown animated" : ""
                              }`}
                  >
                        <nav className="posr">
                              <div className="container posr menu_bdrt1">
                                    <div className="row align-items-center justify-content-between">
                                          <div className="col-auto">
                                                <div className="logos mr40">
                                                      <Link className="header-logo logo1" href="/home">
                                                            <Image
                                                                  width={138}
                                                                  height={44}
                                                                  src="/images/navbar-logo.svg"
                                                                  alt="Header Logo"
                                                            />
                                                      </Link>
                                                      <Link className="header-logo logo2" href="/home">
                                                            <Image
                                                                  width={138}
                                                                  height={44}
                                                                  src="/images/navbar-logo.svg"
                                                                  alt="Header Logo"
                                                            />
                                                      </Link>
                                                </div>
                                                {/* End Logo */}
                                          </div>
                                          {/* End .col-auto */}

                                          <div className="col-auto">
                                                <NavMenu />
                                                {/* End Nav Menu */}
                                          </div>
                                          {/* End .col-auto */}

                                          <div className="col-auto">
                                                <div className="d-flex align-items-center">
                                                      <Link
                                                            className="ud-btn btn-white add-property bdrs60 mx-2 mx-xl-4"
                                                            href={appStoreUrl}
                                                            target="_blank"
                                                      >
                                                            Download Olmo
                                                            <i className="fal fa-arrow-right-long" />
                                                      </Link>
                                                      <Link
                                                            className="login-info d-flex align-items-center mx-2 mx-xl-4"
                                                            href="https://olmohomes.web.app/login"
                                                      >
                                                            <i className="far fa-user-circle fz16 me-2" />
                                                            <span>Login</span>
                                                      </Link>
                                                </div>
                                          </div>
                                          {/* End .col-auto */}
                                    </div>
                                    {/* End .row */}
                              </div>
                        </nav>
                  </header>
                  {/* End Header */}
            </>
      );
};

export default Navbar;
